import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {DcpMessageEvent} from '@app/iframe/interfaces/dcp-message-event';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {combineLatest, Observable} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {map} from 'rxjs/operators';
import {FeatureTogglesService} from '@dcp/configurator';
import {UNLEASH_TOGGLES} from '@app/config/FeatureToggleConfig';

export const CLOSE_EVENT: string = 'closeEvent';
export const ADD_TO_CART_EVENT: string = 'addToCartEvent';
export const LOADING: string = 'loading';
export const STORE_LOADED_EVENT = 'store.loaded';
export const STORE_RESIZE_EVENT = 'store.resize';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class IFrameMessageService {

  constructor(
    protected featureToggleService: FeatureTogglesService,
    protected activatedRoute: ActivatedRoute,
    @Inject(PLATFORM_ID) public platformId: string,
  ) {
  }

  postMessage(message: DcpMessageEvent) {
    if (isPlatformBrowser(this.platformId) && window.parent !== window) {
      window.parent.postMessage(message, '*'); // NOSONAR - this is only used to send event IDs for eg. closing an iframe - no sensitive data
    }
  }

  /**
   * Checks if the application is shown in an iframe.
   */
  isIframe(): boolean {
    return window !== window.top;
  }

  getActiveModalMode(): Observable<'modal' | 'slimModal' | undefined> {
    return combineLatest([
      this.activatedRoute.queryParamMap,
      this.featureToggleService.isEnabled(UNLEASH_TOGGLES.modalView)
    ]).pipe(untilDestroyed(this), map(([value, ft]) => {
      if(!ft) {
        return undefined;
      }
      const mode = value.get('displayMode');
      if (mode === 'modal' || mode === 'slimModal') {
        return mode;
      }
      return undefined;
    }));
  }
}
